import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { joinGameByCode } from "@/api/dashboardApi";

const JoinGame = () => {
  const [privateCode, setPrivateCode] = useState("");
  const navigate = useNavigate();

  const handleEnterGame = async () => {
    if (!privateCode) return;

    const data = await joinGameByCode(privateCode);

    if (!data) return;

    // ⚡️ aunque sea error, mando igual al lobby
    if (data.success) {
      navigate(`/lobby/${data.game.id}`);
    } else if (
      data.errorCode === "INVALID_GAME_STATE" ||
      data.message?.includes("not in lobby state")
    ) {
      // 🔥 entrar igual al lobby aunque ya no esté en LOBBY
      navigate(`/lobby/${privateCode}`);
    }
  };

  return (
    <div className="input-container">
      <input
        type="text"
        placeholder="Código secreto..."
        className="private-code-input"
        value={privateCode}
        onChange={(e) => setPrivateCode(e.target.value)}
      />
      <button className="private-code-btn cta" onClick={handleEnterGame}>
        Entrar 🚀
      </button>
    </div>
  );
};

export default JoinGame;